import { Info } from "lucide-react";
import React from "react";
import { Tooltip } from "src/components/ui/tooltip";

interface SettingsPageHeaderProps {
  title: string;
  tooltip: string;
  children?: React.ReactNode; // For action buttons like "Create Team"
}

export function SettingsPageHeader({ title, tooltip, children }: SettingsPageHeaderProps) {
  return (
    <div className="flex items-center justify-between mb-4 md:mb-6">
      <div className="hidden md:flex items-center gap-1.5">
        <h1 className="text-xl font-medium text-foreground">{title}</h1>
        <Tooltip content={tooltip} position="right" maxWidth="16rem">
          <button className="text-muted-foreground hover:text-foreground transition-colors">
            <Info className="h-3.5 w-3.5" />
          </button>
        </Tooltip>
      </div>
      {children && <div className="md:ml-auto">{children}</div>}
    </div>
  );
}
